// extracted by mini-css-extract-plugin
module.exports = {"logos":"ConferencePartners_logos___RoPG","logo":"ConferencePartners_logo__UbQEJ"};